import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/Layout.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import ResourceManage from '../views/ResourceManage.vue'
import CompanyManage from '../views/CompanyManage.vue'
import Password from '../views/Password.vue'
import FeedbackManage from '../views/FeedbackManage.vue'
import SpecialApplicationManage from '../views/SpecialApplicationManage.vue'
import UserManage from '../views/UserManage.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/login', component: Login },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      children: [
        { path: 'dashboard', component: Dashboard, meta: { title: '工作台' } },
        { path: 'resources', component: ResourceManage, meta: { title: '空置资源管理' } },
        { path: 'companies', component: CompanyManage, meta: { title: '重点企业管理' } },
        { path: 'feedback', component: FeedbackManage, meta: { title: '反馈管理' } },
        { path: 'special-applications', component: SpecialApplicationManage, meta: { title: '专项申请管理' } },
        { path: 'users', component: UserManage, meta: { title: '用户管理', opsOnly: true } },
        { path: 'password', component: Password, meta: { title: '修改密码' } }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && !localStorage.getItem('adminToken')) {
    next('/login')
    return
  }
  if (to.meta && to.meta.opsOnly) {
    const adminUser = JSON.parse(localStorage.getItem('adminUser') || '{}')
    if (adminUser.userType !== 'ops') {
      next('/dashboard')
      return
    }
  }
  next()
})

export default router
